import { render, staticRenderFns } from "./UscStudent.vue?vue&type=template&id=b9cb8506&scoped=true&"
import script from "./UscStudent.vue?vue&type=script&lang=js&"
export * from "./UscStudent.vue?vue&type=script&lang=js&"
import style0 from "./UscStudent.vue?vue&type=style&index=0&id=b9cb8506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cb8506",
  null
  
)

export default component.exports